module.exports = __webpack_public_path__ + "nc_static/media/howto.b27478a4.svg";